import { render, staticRenderFns } from "./AdvertisementSavingList.vue?vue&type=template&id=77492022&scoped=true"
import script from "./AdvertisementSavingList.vue?vue&type=script&lang=js"
export * from "./AdvertisementSavingList.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementSavingList.vue?vue&type=style&index=0&id=77492022&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77492022",
  null
  
)

export default component.exports